import api from './api';

export const getAdminStats = () => api.get('/admin/stats');
export const getAdminUsers = (params) => api.get('/admin/users', { params });
export const updateAdminUser = (userId, data) => api.patch(`/admin/users/${userId}`, data);
export const resetAdminUserPassword = (userId, newPassword) =>
	api.patch(`/admin/users/${userId}/password`, { newPassword });
export const deleteAdminUser = (userId) => api.delete(`/admin/users/${userId}`);